import { DemoPageWidget } from "system/demo";
import { Feature } from "util/stdtypes";
import { ProfileConfig } from "structure/profile";

export const ProfileConfigFeature: Feature<ProfileConfig, {}> = {
    name: 'Show Config Slots',
    key: 'config_profile',
    providesConfig: {
        profileWidgets: [ProfileWidget]
    }   
}

function ProfileWidget(): JSX.Element {
    return <DemoPageWidget text='Profile Widget' />;
}


